// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__125MB","subheader":"ReorderModal_subheader__1U8Vl","listWrap":"ReorderModal_listWrap__1KLIT"};